<template>
  <div id="navbar">
    <el-menu :default-active="defaultActives" class="el-menu-demo" mode="horizontal" background-color="#fff" text-color="#bdbdbd" active-text-color="#fff">
      <el-menu-item v-for="childItem in list" :key="childItem.name" :index="childItem.name" @click="toPage(childItem.path)">
        <i class="elicon" :class="childItem.icon"></i>
        <span>{{ childItem.name }}</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  components: {},
  computed: {
    ...mapState('routeData', {
      routerMetas: state => state.routerMetas,
      // defaultActive: (state) => state.defaultActive,
    }),
    defaultActives() {
      return this.$store.state.routeData.defaultActive;
    },
  },
  created() {
    this.setDefaultActive();

    this.getdata();
  },
  data() {
    return {
      list: [],
      iconList: [
        { icon: 'el-icon-dish-1' },
        { icon: 'el-icon-s-custom' },
        { icon: 'el-icon-s-cooperation' },
        // { icon: "el-icon-s-order" },
        { icon: 'el-icon-folder-checked' },
        { icon: 'el-icon-s-platform' },
        { icon: 'el-icon-tableware' },
      ],
      activeIndex: '1',
      StoragePath: '',
      activeIndex2: '1',
      defaultActives: '',
    };
  },
  watch: {
    $route(to, from) {
      console.log('route', to, from);
      if (to.name == 'MenuQuery') {
        this.defaultActives = '餐单查询';
      } else if (to.name == 'dashboard') {
        this.defaultActives = '台位';
      } else if (to.name == 'reserve') {
        this.defaultActives = '预订';
      } else if (to.name == 'breakfast') {
        this.defaultActives = '自助';
      }
    },
  },
  mounted() {
    this.$bus.on('MenuQuery', val => {
      this.toPage('MenuQuery');
    });
    this.$bus.on('dashboard', val => {
      this.toPage('dashboard');
    });
  },
  methods: {
    ...mapActions('routeData', ['setDefaultActive']),

    toPage(path) {
      console.log('toPage', path);
      if (this.StoragePath === path) {
      } else {
        this.StoragePath = path;
        this.$router.push({
          name: path,
        });

        if (path == 'dashboard') {
          this.$store.commit('routePathDashboard');
        }

        if (path == 'MenuQuery') {
          this.$store.commit('routePathMenuQuery');
        }
      }
    },
    getdata() {
      let url = this.api.isBreakfast;
      let methods = 'get';
      let data = {
        posCode: localStorage.getItem('posCode'),
      };
      this.$axios({ url, methods, data }).then(res => {
        if (!res.data.status) {
          console.log('动态 路由', this.routerMetas);
          let isBreakfast = res.data.data;
          this.routerMetas.forEach((v, i) => {
            if (v.name == '自助') {
              if (isBreakfast) {
                this.list.push(v.list[0]);
              }
            } else {
              this.list.push(v.list[0]);
            }
          });

          // this.list.push(this.iconList)
          for (let i in this.list) {
            for (let s in this.iconList) {
              this.list[i].icon = this.iconList[i].icon;
            }
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-menu-item.is-active {
  background-color: #0099ff !important;
  color: #fff;
}

.el-menu-demo {
  height: 100%;
  display: flex;
  align-items: center;
}

.el-menu-item {
  width: 100px;
  line-height: 10px;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.elicon {
  margin-bottom: 16px;
  font-size: 18px;
}

#navbar {
  width: 100%;
  overflow: hidden;
  overflow-y: auto;
}
</style>
